import { actionTypes } from 'redux-resource';

import NetworkError from 'helpers/networkErrorClass';
import * as api from '../api';

export const fetchQuickCarrierRequests =
  (subId, page = 1) =>
  (dispatch) => {
    const PAGE_SIZE = 50;
    const actionDefaults = {
      resourceType: 'quickCarrierRequests',
      requestKey: `quickCarrierRequests_${subId}_${page}`,
      list: `quickCarrierRequests_${subId}_${page}`,
      mergeListIds: false,
    };

    dispatch({
      ...actionDefaults,
      type: actionTypes.READ_RESOURCES_PENDING,
    });

    return api
      .fetchQuickCarrierRequests(subId, { page_size: PAGE_SIZE, page })
      .then(async (response) => {
        const next =
          response?.data?.carrier_requests?.length === PAGE_SIZE
            ? page + 1
            : null;
        let count =
          (page - 1) * PAGE_SIZE + response?.data?.carrier_requests?.length;
        if (next) {
          count += PAGE_SIZE;
        }
        dispatch({
          ...actionDefaults,
          type: actionTypes.READ_RESOURCES_SUCCEEDED,
          resources: response.data.carrier_requests,
          requestProperties: {
            perPage: PAGE_SIZE,
            count,
            next,
            previous: page > 1 ? page - 1 : null,
          },
        });
      })
      .catch((err) => {
        dispatch({
          ...actionDefaults,
          type: actionTypes.READ_RESOURCES_FAILED,
        });
        throw new NetworkError('Failed to load carrier requests.');
      });
  };
